
import PageRoute from './PageRoute';

export const OpenServiceGuardConstant = [PageRoute.COMPANY_MANAGEMENT];